import React from 'react';
import styles from './TextCursor.module.scss';

const TextCursor: React.FC = () => (
  <span className={styles.wrapper}>
    <span className={styles.container}>
      <span className={styles.backgroundCursor} />
      <span className={styles.mainCursor} />
    </span>
  </span>
);

export default TextCursor;
